var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabHistory"},[_c('div',{staticClass:"tabHistory__item",class:{
      'tabHistory__item--active': !_vm.isWithdraw
    },on:{"click":function($event){return _vm.$router.replace('/tai-khoan/lich-su-nap-tien/')}}},[_vm._v(" nạp tiền ")]),_c('div',{staticClass:"tabHistory__item",class:{
      'tabHistory__item--active': _vm.isWithdraw
    },on:{"click":function($event){return _vm.$router.replace('/tai-khoan/lich-su-giao-dich/')}}},[_vm._v(" rút tiền ")])])}
var staticRenderFns = []

export { render, staticRenderFns }